/**
 * API CompagnonCPS
 * API pour le connecteur CompagnonCPS
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface RechercheEPrescription { 
    typePrescription?: string;
    sousType?: string;
    datePrescriptionDebut?: string;
    datePrescriptionFin?: string;
    dateExecutionDebut?: string;
    dateExecutionFin?: string;
    dateModificationDebut?: string;
    dateModificationFin?: string;
    numNIROD?: string;
    numNIR?: string;
    dateNai?: string;
    rang?: number;
    numeroAMRemplace?: string;
    numeroFinessRemplace?: string;
}

